<template>
  <div class="pagination-wrapper">
    <div class="pagination-wrapper__filters" v-if="!isHomePage">
      <Filters :hasActiveFilters="hasActiveFilters" />

      <div class="store-sidebar__clear" v-if="hasActiveFilters" :class="{ active: isBurgerActive }">
        <button class="filters-clear" @click.prevent="removeFilters">
          {{ translations.emptyFilters }}
          <i data-feather="x"></i>
        </button>
      </div>
    </div>

    <div class="pagination-row">
      <div class="found-posts">
        {{ translations.postsFound }}:
        <p v-if="this.getShowedProductsCount !== 0">
          {{ this.getShowedProductsCount }} /
          {{ this.$store.state.productsCount }}
        </p>
      </div>

      <div class="pagination-row__actions">
        <div class="perpage">
          <p>
            <span>{{ translations.perPage }}: </span>
          </p>

          <div class="perpage__buttons">
            <button
              v-for="option in $store.state.view.perPageOptions"
              :key="option"
              :class="{ active: option === $store.state.view.perPage }"
              @click="setSelectedPerPage(option)"
            >
              {{ option }}
            </button>
          </div>
        </div>

        <div class="select-view">
          <div class="select-view__table">
            <button v-bind:class="[this.$store.state.view.type == 'wells' ? 'selected' : '']" v-on:click="setView('wells')">
              <i data-feather="pause"></i>
            </button>
          </div>
          <div class="select-view__grid">
            <button v-bind:class="[this.$store.state.view.type == 'kaali' ? 'selected' : '']" v-on:click="setView('kaali')">
              <i data-feather="grid"></i>
            </button>
          </div>
        </div>

        <div class="sort">
          <v-select
            name="sort_page"
            id="sort_page"
            :clearable="false"
            :options="sorts"
            :searchable="false"
            :filterable="false"
            :value="$store.state.view.sort"
            @input="setSelectedSort"
          ></v-select>
        </div>
      </div>

      <div class="select-page">
        <button
          class="select-page__prev"
          v-on:click="prevPage"
          v-bind:class="{ disabled: this.$store.state.view.page == 1 }"
        >
          <span>‹</span>
        </button>
        <p>{{ $store.state.view.page }} / {{ this.getPageCount }}</p>
        <button
          class="select-page__next"
          v-on:click="nextPage"
          v-bind:class="{ disabled: this.$store.state.view.page == this.getPageCount }"
        >
          <span>›</span>
        </button>
      </div>

      <v-pagination
        v-model="$store.state.view.page"
        v-if="getPageCount > 0"
        :page-count="getPageCount"
        :classes="pagination.classes"
        :labels="pagination.anchorTexts"
        @input="setPage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import vPagination from "vue-plain-pagination";
import Filters from "@/layouts/archive/sidebar/Filters.vue";
import feather from 'feather-icons';

export default {
  components: {
    vPagination,
    Filters
  },
  name: "PaginationWells",
  data() {
    return {
      translations: {
        sort: ws_vue_store.translations.sort,
        perPage: ws_vue_store.translations.per_page,
        postsFound: ws_vue_store.translations.posts_found,
        emptyFilters: ws_vue_store.translations.empty_filters
      },
      sorts: ws_vue_store.catalog_orderby_options,
      pagination: {
        currentPage: this.$store.state.view.page,
        classes: {
          ul: "pagination",
          li: "pagination-item",
          liActive: "pagination-item--active",
          liDisable: "pagination-item--disable",
          button: "pagination-link",
          buttonActive: "pagination-link--active",
          buttonDisable: "pagination-link--disable"
        },
        anchorTexts: {
          first: "&laquo;",
          prev: "&lsaquo;",
          next: "&rsaquo;",
          last: "&raquo;"
        },
      },
      isBurgerActive: false,
    };
  },
  computed: {
    isHomePage() {
      return this.$store.getters.isHomePage();
    },
    hasActiveFilters() {
      return this.$store.getters.getActiveFiltersCount > 0;
    },
    getPageCount() {
      return Math.ceil(this.$store.state.productsCount / this.$store.state.view.perPage);
    },
    getShowedProductsCount() {
      let minPerPage = (this.$store.state.view.page - 1) * this.$store.state.view.perPage + 1;
      if (this.$store.state.productsCount < this.$store.state.view.perPage) {
        return this.$store.state.productsCount;
      }
      if (this.$store.state.view.page == this.getPageCount) {
        let lessPerPage =
          this.$store.state.view.page * this.$store.state.view.perPage -
          this.$store.state.productsCount;
        let maxPerPage = this.$store.state.view.page * this.$store.state.view.perPage - lessPerPage;
        return minPerPage + "-" + maxPerPage;
      }
      let maxPerPage = this.$store.state.view.page * this.$store.state.view.perPage;
      return minPerPage + "-" + maxPerPage;
    }
  },
  methods: {
    removeFilters() {
      this.$store.commit('changeProductsLoadingState', true);
      this.$store.commit('clearFilters', {
        'ignoreCategory': ws_vue_store.empty_filters_ignore_category
      });
      this.$store.commit('updateUrlQuery');
      this.$store.commit('updateCategoryPath');
      this.$store.commit("isCurrentCategoryRent");
      this.$store.dispatch("getFilteredAttributes", []).then(() => this.$store.dispatch("getProducts", []));
    },
    setView(value) {
      if (window.innerWidth <= 1350) {
        value = 'kaali';
      }
      this.$store.commit("changeViewType", value);
    },
    setSelectedPerPage(value) {
      this.$store.commit("changePerPage", value);
      this.$store.commit("setFirstPage");
      this.$store.dispatch("getProducts");
    },
    setSelectedSort(value) {
      this.$store.commit("setSort", value);
      this.$store.commit("setFirstPage");
      this.$store.dispatch("getProducts");
    },
    setPage() {
      this.$store.commit("changeCurrentPage", this.$store.state.view.page);
      this.$store.dispatch("getProducts");
    },
    nextPage() {
      if (this.$store.state.view.page < this.getPageCount) {
        this.$store.commit("changeCurrentPage", (this.$store.state.view.page += 1));
        this.$store.dispatch("getProducts");
      }
    },
    prevPage() {
      if (this.$store.state.view.page > 1) {
        this.$store.commit("changeCurrentPage", (this.$store.state.view.page -= 1));
        this.$store.dispatch("getProducts");
      }
    }
  },
  mounted() {
    feather.replace();
  },
};
</script>

<style lang="scss">
.pagination-row {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  align-items: center;
  padding: 4rem 0 2rem;

  > div {
    .vs--single.vs--open .vs__selected {
      position: relative;
    }

    .vs5__listbox {
      width: 100%;
    }

    .vs {
      &--searchable {
        padding: 0 1rem;
      }

      &--single {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        ul {
          position: absolute;
          top: 100%;
          right: 0;
          left: inherit;
          z-index: 9;
          width: 100%;
          font-size: 1.6rem;
          background-color: $color-white;
          border: 1px solid $color-black;
          border-radius: 0 0 1rem 1rem;
        }

        &.vs--open {
          .vs__dropdown-toggle {
            border-bottom: 0;
            border-radius: 1rem 1rem 0 0;
          }
        }
      }

      &__actions {
        svg {
          transform: scale(0.6);
        }
      }

      &__dropdown-menu {
        padding: 0;
      }

      &__dropdown-option {
        padding: 1rem 2rem;
        white-space: wrap;

        &--highlight {
          color: $color-white;
          background-color: #006646;
        }
      }

      &__dropdown-toggle {
        display: flex;
        gap: 4rem;
        align-items: center;
        padding: 1rem 1.4rem 1rem 2rem;
        background: none;
        border: 1px solid black;
        border-radius: 1rem;
        white-space: normal;
        appearance: none;

        @include small {
          width: 100%;
          justify-content: space-between;
        }
      }

      &__selected-options {
        display: flex;
        line-height: 100%;

        input {
          display: none;
        }
      }
    }
  }

  .select-page {
    button {
      &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }
  }

  .pagination {
    display: flex;

    &-item {
      padding: 0 1rem;
      align-self: center;
    }
  }

  .select-view {
    button {
      opacity: 0.9;
      transition: all .3s ease-in-out;

      &:not(.selected) {
        opacity: 0.3;
      }

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>